import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Button from 'components/CustomButtons/Button.js'
import Parallax from 'components/Parallax/Parallax.js'
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import styles from 'assets/jss/material-kit-react/views/indexPage.js'

// Sections for this page
import ServiceSection from './Sections/ServiceSection.js'
import IdeaSection from './Sections/IdeaSection.js'
import PeopleSection from './Sections/PeopleSection.js'
import HistorySection from '../CompanyPage/Sections/HistorySection.js'

import { Link } from 'react-router-dom'

const useStyles = makeStyles(styles)

export default function IndexPage(props) {
  const classes = useStyles()
  const { ...rest } = props

  return (
    <div>
      <MyHeader
        color="transparent"
        brand="江苏硕佰建筑科技有限公司"
        fixed
        rightLinks={<MyHeaderLinks />}
        changeColorOnScroll={{
          height: 400,
          color: 'white',
        }}
        {...rest}
      />
      <Parallax filter image={require('assets/img/index-bg.jpg')}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>您的绿色 & 智慧专家</h1>
              <h1 className={classes.subtitle}>Sustainable & Intelligent Expert</h1>
              <h4>
                我们是绿色建筑行业的设计师，也是生态文明的践行者，致力于为客户提供高附加值的解决方案。我们不断开拓进取，用科技去引领生活，用创新去规划未来，为人类提供安全、舒适、健康、智慧的生活环境。
              </h4>
              <br />
              <Link to="/company" className={classes.navButton}>
                <Button color="primary" size="lg">
                  了解更多
                </Button>
              </Link>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <HistorySection />
          <ServiceSection />
          <IdeaSection />
          <PeopleSection />
        </div>
      </div>
      <MyFooter />
    </div>
  )
}
